import getData from './get-data';
import getGroupedElements from './get-grouped-elements';

export default {
  getGroupedElements,
  getDataFromElement: getData,
};
